import React, { Fragment } from 'react';
import Bayout from '../../components/blogLayout';
import BlogListItem from '../../components/blogListItem';
import { graphql } from 'gatsby';
import Seo from '../../components/seo';

const BlogCategory = ({ data, pageContext: { name, slug, numPages, current } }) => {
    const categoryBasePath = `/blog/category/${slug}/`;

    return (
        <Bayout hasPage={true} numPages={numPages} currentPage={current} pageBasePath={categoryBasePath}>
            <div className="blog-section-title">{name}</div>
            <div className="blog-list d-flex flex-column">
                {data.allWpPost.edges.map(({ node }, i) => (
                    <Fragment key={node.id}>
                        <BlogListItem node={node} />
                        {i < data.allWpPost.edges.length - 1 && <hr />}
                    </Fragment>
                ))}
            </div>
        </Bayout>
    );
};

export default BlogCategory;

export const query = graphql`
    query ($slug: String!, $limit: Int!, $skip: Int!) {
        allWpPost(
            sort: { date: DESC }
            limit: $limit
            filter: { categories: { nodes: { elemMatch: { slug: { eq: $slug } } } } }
            skip: $skip
        ) {
            edges {
                node {
                    title
                    excerpt
                    slug
                    uri
                    id
                    date(formatString: "YYYY/MM/DD")
                    categories {
                        nodes {
                            name
                            uri
                        }
                    }
                    featuredImage {
                        node {
                            sourceUrl
                        }
                    }
                }
            }
        }
    }
`;

export const Head = ({ pageContext }) => <Seo pageContext={pageContext} />;
